import httpClientFactory from '@/modules/core/services/httpClientFactory';
import { clearStorage } from '../shared/storage';
import jwtDecode from 'jwt-decode';

export const login = async(credential) => {
  try {
    const httpClient = httpClientFactory();
    const response = await httpClient.post('sessoes', {
      email: credential.username,
      senha: credential.password,
      identificadorDispositivo: 'web',
    });
    const profile = response.data.usuario;

    localStorage.clear();
    sessionStorage.clear();

    const storage = credential.keepOn ? localStorage : sessionStorage;

    storage.setItem('access_token', response.data.token);
    storage.setItem('refresh_token', response.data.refreshToken);
    storage.setItem('username', profile.nome);
    storage.setItem('email', profile.email);
    const decodedToken = jwtDecode(response.data.token);
    storage.setItem('tipoUsuario', decodedToken.tipoUsuario);

    return true;
  } catch (error) {
    if (error.response.status === 401 || error.response.status === 400) return false;
    throw error;
  }
};

export const directLogin = (credential) => {
  localStorage.clear();
  sessionStorage.clear();

  sessionStorage.setItem('access_token', credential.token);
  sessionStorage.setItem('refresh_token', credential.refreshToken);
  sessionStorage.setItem('username', credential.nome);
  sessionStorage.setItem('email', credential.email);
  const decodedToken = jwtDecode(credential.token);
  sessionStorage.setItem('tipoUsuario', decodedToken.tipoUsuario);
  return true;
};

export const rescue = async(email) => {
  const httpClient = httpClientFactory();
  await httpClient.post('/usuarios/recuperarSenha', email);
};

export const logout = () => {
  clearStorage();
};
